import { render, staticRenderFns } from "./ProductProfit.vue?vue&type=template&id=752b15dd&scoped=true"
import script from "./ProductProfit.vue?vue&type=script&lang=js"
export * from "./ProductProfit.vue?vue&type=script&lang=js"
import style0 from "./ProductProfit.vue?vue&type=style&index=0&id=752b15dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752b15dd",
  null
  
)

export default component.exports